import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Input,
  message,
  Modal,
  Row,
  Select,
  Tabs,
  Upload,
} from "antd";
import Title from "antd/lib/typography/Title";
import { useFormik } from "formik";
import _, { uniqBy } from "lodash";
import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import * as Yup from "yup";
import { AddMerchantsField as AddMerchantField } from "../../actions/companySettings";
import {
  AddExpense,
  addExpense,
  expenseDetails,
  expenseFields,
  expensesReset,
  ExpenseViolations,
} from "../../actions/expenses/expenses";
import { apis } from "../../config/APIs";
import endpoint from "../../config/Axios";
import { objectToFormData } from "../../utils";
import {
  UserReportLinkExp,
  userReportLinkExp,
} from "../../actions/reports/reports";

import ImageSwiper from "../Common/ImageSwiper";
import AddReport from "../Reports/AddReport";
import AddMerchantsField from "../Settings/Customisation/Merchants/AddMerchantsField";
import AddToReportDropdown from "./AddToReportDropdown";

import "./expenses.css";
const { TabPane } = Tabs;
// const { TextArea } = Input;
const AddExpenses = (props) => {
  const addExpenseResponse = useSelector(
    (state) => state.expenses.addExpense || {},
  );
  const userReportLinkExpResponse = useSelector(
    (state) => state.reports.userReportLinkExp || {},
  );
  const expenseFieldsResponse = useSelector(
    (state) => state.expenses.expenseFields || {},
  );
  const expensesResponse = useSelector(
    (state) => state.expenses.expenseDetails?.data?.response || {},
  );

  const location = useLocation();
  const history = useHistory();
  const { data: { response: { fields: expensesFieldsData = [] } = {} } = {} } =
    expenseFieldsResponse;

  const dispatch = useDispatch();
  const [uploadFileData, setUploadFileData] = React.useState([]);
  const [dataURIs, setDataURIs] = React.useState([]);
  const [delIds, setDelIds] = React.useState([]);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [isModalVisibleReport, setIsModalVisibleReport] = React.useState(false);
  const [searchVal, setSearchVal] = React.useState("");
  const [checkDisabled, setCheckDisabled] = React.useState(false);
  const [validationSchema, setValidationSchema] = React.useState(null);
  const [selectedReport, setSelectedReport] = React.useState(null);

  const addMerchantsFieldResponse = useSelector(
    (state) => state.companySetting.addMerchantsField || {},
  );
  const formik = useFormik({
    initialValues: {
      claim_reimbursement: true,
      amount_cents: "",
      category_id: "",
      transaction_date: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (vals) => {
      let arr = [];
      let merchant_name = "";
      Object.keys(vals).forEach((ele) => {
        if (ele === "merchant_name") {
          merchant_name = vals[ele];
        } else {
          arr.push({
            id: ele,
            value: vals[ele],
          });
        }
      });
      if (location?.state?.id)
        dispatch(
          addExpense({
            files: uploadFileData?.map((ele) => ele?.originFileObj),
            field_values: arr,
            id: location?.state?.id,
            delete_file_ids: delIds,
            merchant_name,
          }),
        );
      else
        dispatch(
          addExpense({
            files: uploadFileData?.map((ele) => ele?.originFileObj),
            field_values: arr,
            merchant_name,
          }),
        );
    },
  });

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = addMerchantsFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(
        expenseFields({
          id: location?.state?.id,
        }),
      );
      dispatch({
        type: AddMerchantField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addMerchantsFieldResponse]);

  React.useEffect(() => {
    const {
      data: {
        status = "",
        message: res_message = "",
        response: { transaction = {} } = {},
      } = {},
    } = addExpenseResponse;
    if (status) {
      // dispatch(expenses());

      if (selectedReport && transaction?.id) {
        // Link logic moved here
        const payload = {};
        payload.transactions = [transaction.id];
        payload.id = selectedReport;

        endpoint
          .post(
            apis.validate_expense,
            {
              transaction_ids: payload.transactions,
            },
            { skipSuccessMessage: true },
          )
          .then((res) => {
            let txns = res.data?.response?.transactions || [];
            let policies = [];
            txns?.forEach((ele) => {
              policies = [
                ...policies,
                ...ele?.policies?.map((e) => e.is_blocked && e.errors?.length),
              ];
            });

            if (policies?.filter((ele) => ele)?.length) {
              props.setShowViolations && props.setShowViolations(true);
              props.setViolations && props.setViolations(txns);
              dispatch({
                type: ExpenseViolations,
                payload: {
                  policyViolations: txns,
                  policyModal: true,
                },
              });
            } else {
              dispatch(userReportLinkExp(objectToFormData(payload)));
            }
          });
      } else {
        if (!props.reportId) history.push("/expenses/");
      }

      dispatch({
        type: AddExpense.RESET,
      });
      setDelIds([]);
    } else if (status === false) {
      if (res_message) {
        dispatch({
          type: AddExpense.RESET,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addExpenseResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      userReportLinkExpResponse;
    if (status) {
      dispatch({
        type: UserReportLinkExp.RESET,
      });
      if (!props.reportId) history.push("/expenses/");
    } else if (status === false) {
      if (res_message) {
        dispatch({
          type: UserReportLinkExp.RESET,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReportLinkExpResponse]);

  React.useEffect(() => {
    if (location.state?.isEdit) {
      dispatch(
        expenseFields({
          id: location?.state?.id,
        }),
      );
      dispatch(expenseDetails({ id: location?.state?.id }));
    } else {
      dispatch(expenseFields());
    }
    if (props.resetForm) props.resetForm(formik.resetForm);
    message.config({
      maxCount: 1,
    });
    return () => {
      dispatch(expensesReset());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let arr = {};
    if (
      expensesFieldsData &&
      expensesFieldsData?.length > 0 &&
      location.state?.isEdit
    ) {
      expensesFieldsData.forEach((item) => {
        arr[item.field_id] =
          item.field_type === "dropdown" && item.selected.id
            ? item.selected.id
            : item.selected.value;
      });
      formik.setValues({
        ...arr,
        merchant_name: expensesResponse?.transactions?.[0]?.merchant_name,
        category_id: formik.values.category_id
          ? formik.values.category_id
          : arr.category_id,
      });
    }
    if (expensesFieldsData && expensesFieldsData?.length && !validationSchema) {
      let obj = {};
      let obj2 = {};
      expensesFieldsData.forEach((item) => {
        if (item.is_required) {
          const field_id = ["transaction_merchant_id"].includes(item.field_id)
            ? "merchant_name"
            : item.field_id;
          obj2[field_id] = formik.values[field_id] || "";
          obj[field_id] = Yup.string()
            .required(`${item.display_name} is required`)
            .nullable();
        }
      });

      if (!location.state?.isEdit) {
        formik.setValues({
          ...obj2,
          ...arr,
        });
      }
      setValidationSchema(Yup.object().shape(obj));
    }
    // eslint-disable-next-line
  }, [expensesFieldsData, expensesResponse]);

  useEffect(() => {
    if (location.state?.isEdit) {
      setUploadFileData(
        location.state.files?.map((ele, i) => ({
          uid: (i + 1) * -1,
          name: ele.id,
          url: ele.file,
          status: "done",
          thumbUrl: ele.file,
        })),
      );
      setDataURIs(
        location.state.files?.map((ele, i) => ({
          src: ele.file,
          uid: (i + 1) * -1,
        })),
      );
    }
    // eslint-disable-next-line
  }, []);

  const handleChange = (val, id) => {
    formik.setFieldValue(id, val);
  };

  const renderDataTypes = (value, default_values, id, name, is_disabled, display_name) => {
    switch (value) {
      case "string":
        return (
          <>
            <Input
              placeholder={`Enter ${display_name}`}
              value={formik.values?.[id]}
              style={{ minWidth: "216px" }}
              onChange={(e) => {
                handleChange(e.target.value?.trimStart(), id);
              }}
            />
            <div className="error">
              {formik.touched?.[id] && formik.errors?.[id]}
            </div>
          </>
        );
      case "integer":
        return (
          <>
            <Input
              disabled={is_disabled}
              placeholder={`Enter ${display_name}`}
              type="text"
              value={formik.values?.[id]}
              style={{ minWidth: "216px" }}
              onChange={(e) => {
                if (Number.isNaN(Number(e.target.value))) {
                  return;
                }
                handleChange(e.target.value?.trimStart(), id);
              }}
            />
            <div className="error">
              {formik.touched?.[id] && formik.errors?.[id]}
            </div>
          </>
        );
      case "dropdown":
        return name?.includes("merchant_id") ? (
          <>
            <Input
              placeholder={`Enter ${display_name}`}
              value={formik.values?.["merchant_name"]}
              style={{ minWidth: "216px" }}
              onChange={(e) => {
                handleChange(e.target.value?.trimStart(), "merchant_name");
              }}
            />
            <div className="error">
              {formik.touched?.["merchant_name"] &&
                formik.errors?.["merchant_name"]}
            </div>
          </>
        ) : (
          <>
            <Select
              style={{ width: 200 }}
              placeholder={`Select ${display_name}`}
              showSearch={name?.includes("merchant_id")}
              value={
                formik.values?.[id]
                  ? default_values?.find(
                    (ele) => ele.id === formik.values?.[id],
                  )?.value
                  : undefined
              }
              onSearch={(val) => {
                setSearchVal(val);
              }}
              searchValue={searchVal}
              notFoundContent={
                name?.includes("merchant_id") ? (
                  <Button
                    type="text"
                    className="merchant-btn"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setIsModalVisible(true);
                    }}
                  >
                    Add Merchant
                  </Button>
                ) : (
                  <div>No Data</div>
                )
              }
              onChange={(val, data) => {
                if (name === "category_id") {
                  let obj = {
                    category_id: data.id,
                  };
                  if (location?.state?.id) {
                    obj.id = location?.state?.id;
                  }
                  dispatch(expenseFields(obj));
                }
                if (val === "Personal") {
                  formik.setFieldValue("claim_reimbursement", false);
                  setCheckDisabled(true);
                }
                if (val === "Company") {
                  formik.setFieldValue("claim_reimbursement", true);
                  setCheckDisabled(false);
                }
                handleChange(data.id, id);
              }}
              disabled={is_disabled}
              options={
                default_values &&
                default_values.map(({ id, value }) => ({
                  label: value,
                  value: value,
                  id,
                }))
              }
            />
            <div className="error">
              {formik.touched?.[id] && formik.errors?.[id]}
            </div>
          </>
        );
      case "checkbox":
        return (
          <>
            <Checkbox
              style={{ float: "left" }}
              checked={formik.values?.[id]}
              disabled={checkDisabled}
              onChange={(e) => {
                handleChange(e.target.checked, id);
              }}
            >
              {_.startCase(name)}
            </Checkbox>
            <div className="error">
              {formik.touched?.[id] && formik.errors?.[id]}
            </div>
          </>
        );
      case "datetime":
        return (
          <>
            <DatePicker
              disabled={is_disabled}
              value={
                formik.values?.[id]
                  ? moment(formik.values?.[id], [
                    "DD MMM'YY, HH:mm:ss a",
                    "YYYY-MM-DD HH:mm:ss",
                  ])
                  : null
              }
              onChange={(date, dateString) => {
                handleChange(dateString, id);
              }}
              showTime
            />
            <div className="error">
              {formik.touched?.[id] && formik.errors?.[id]}
            </div>
          </>
        );
      default:
      // code block
    }
  };

  const readAsDataURL = (file, index) => {
    return new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onerror = reject;
      fr.onload = function () {
        resolve({
          src: fr.result,
          type: fr.result.includes("image") ? "image" : "pdf",
          uid: index,
        });
      };
      fr.readAsDataURL(file);
    });
  };

  const onFileRemove = (info) => {
    let idx = uploadFileData?.findIndex((ele) => ele.uid === info.uid);
    let idx2 = dataURIs?.findIndex((ele) => ele.uid === info.uid);
    if (idx > -1) {
      let fileData = [...uploadFileData];
      setDelIds((d) => [...d, fileData[idx].name]);
      fileData.splice(idx, 1);
      setUploadFileData(fileData);
    }
    if (idx2 > -1) {
      let uris = [...dataURIs];
      uris.splice(idx2, 1);
      setDataURIs(uris);
    }
  };

  const onFileChange = (info) => {
  const maxFiles = 5;

    if (info?.file?.status === "removed") {
      return;
    }

    // const currentFileNames =
    //   uploadFileData?.map((ele) => ele?.name?.toLowerCase()) || [];
    // const newFileName = info?.file?.name?.toLowerCase();

    // if (newFileName && currentFileNames.includes(newFileName)) {
    //   message.error(
    //     <span className="messageText">
    //       File "{info?.file?.name}" has already been uploaded. Please use a
    //       different file.
    //     </span>,
    //   );
    //   return;
    // }

    setUploadFileData((list) => uniqBy([...list, ...info.fileList], "uid"));
    if (info.fileList?.length > 0) {
      let arr = [];
      info.fileList.forEach((ele) => {
        if (ele?.originFileObj) {
          arr.push(
            new Promise((resolve, reject) => {
              readAsDataURL(ele?.originFileObj, ele?.originFileObj?.uid)
                .then((res) => {
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            }),
          );
        }
      });
      Promise.all(arr).then((res) => {
        let arr = dataURIs;
        // if (location.state && location.state.files) {
        //   arr = location.state.files?.map((ele, i) => ({ src: ele.file, uid: (i + 1) * -1 }))
        // }
        res.forEach((ele) => arr.push(ele));
        setDataURIs(uniqBy([...arr], "uid"));
      });
    }
  };;

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Modal
        title={
          <Title level={4}>
            New Report &nbsp;
            <span className="text-small">Enter details and submit</span>
          </Title>
        }
        visible={isModalVisibleReport}
        onCancel={() => {
          setIsModalVisibleReport(false);
        }}
        footer={[]}
        className="right-alinged-modal"
      >
        {isModalVisibleReport && (
          <AddReport
            handleCancel={() => {
              setIsModalVisibleReport(false);
            }}
          />
        )}
      </Modal>
      <Tabs type="card" size="large" className="custom-tabs">
        <TabPane tab="Add Expenses" key="preferences">
          <div className="tabContentWrapper userContentWrap">
            <form className="modal-form" onSubmit={formik.handleSubmit}>
              <Row className="">
                <Col span={14}>
                  <ImageSwiper
                    fileList={uploadFileData}
                    onFileChange={onFileChange}
                    imgs={dataURIs}
                    onFileRemove={onFileRemove}
                  />
                </Col>
                <Col span={10} className="p3 overflowCol">
                  {expensesFieldsData.length &&
                    expensesFieldsData.map((item) =>
                      item.field_name === "cost center" ? null : (
                        <div className="nameItem">
                          {item.field_type !== "checkbox" && (
                            <label
                              className={`inline-block ${item.is_required ? "required" : ""
                                }`}
                            >
                              {item.display_name}
                            </label>
                          )}
                          <br />
                          {renderDataTypes(
                            item.field_type,
                            item.default_values,
                            item.field_id,
                            item.field_name,
                            [
                              "amount_cents",
                              "transaction_date",
                              "transaction_merchant_id",
                            ].includes(item.field_name) &&
                            location?.state?.card_ref,
                            item.display_name,
                          )}
                        </div>
                      ),
                    )}
                  <div className="nameItem">
                    <label className={`inline-block`}>{"Add to Report"}</label>
                    <AddToReportDropdown
                      hasId={
                        addExpenseResponse?.data?.response?.transaction?.id
                      }
                      addReport={() => {
                        setIsModalVisibleReport(true);
                      }}
                      setViolations={props.setViolations}
                      setShowViolations={props.setShowViolations}
                      value={selectedReport}
                      onChange={setSelectedReport}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="submitRow">
                <Button
                  key="2"
                  className="cancelButton mt1"
                  type="button"
                  onClick={() => {
                    if (props.reportId) {
                      formik.resetForm();
                      props.handleCancel();
                    } else history.push("/expenses");
                  }}
                >
                  Cancel
                </Button>
                <Button
                  key="15"
                  htmlType="submit"
                  className="formButton ml1 mt1 primaryButton"
                  disabled={addExpenseResponse.loading}
                >
                  Save and Close
                </Button>
              </Row>
            </form>
          </div>
        </TabPane>
      </Tabs>
      <Modal
        title={
          <Title level={4}>
            New Merchant &nbsp;
            <span className="text-small">Enter details and submit</span>
          </Title>
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className={"right-alinged-modal-small"}
      >
        {isModalVisible && <AddMerchantsField handleCancel={handleCancel} />}
      </Modal>
    </>
  );
};

export default AddExpenses;
